import React, { useState } from 'react';
import Form from 'antd/es/form';
import './Login.css';
import centralApi from 'services/centralApi';
import { Helmet } from 'react-helmet';
import Spinner from 'components/Spinner/Spinner';
import { t } from 'i18next';
import TextInput from 'components/Inputs/TextInput/TextInput';
import PrimaryButton from 'components/Buttons/PrimaryButton/PrimaryButton';
import { BOOLEAN_OPTIONS } from 'utils/constants/selectorOptions';
import { useForm } from 'antd/es/form/Form';
import useMessage from 'hooks/useMessage';
import { useDiagnosticsAuth } from 'pages/Diagnostics/context/DiagnosticsAuthContext';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS, ROUTES } from 'utils/constants';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(BOOLEAN_OPTIONS.FALSE);
  const [formValues, setFormValues] = useState<any>({});
  const [form] = useForm();
  const { showError } = useMessage();
  const { login } = useDiagnosticsAuth();
  const navigate = useNavigate();

  //handle input change
  const handleFieldChange = (data: any) => {
    setFormValues((prevState: any) => ({ ...prevState, ...data }));
  };

  const handleSubmit = async () => {
    setLoading(BOOLEAN_OPTIONS.TRUE);
    try {
      const payload = {
        args: JSON.stringify({ email: formValues.email, password: formValues.password })
      };
      const res = await centralApi('POST', API_ENDPOINTS.DIAGNOSTICS_LOGIN, payload);
      if (res && res.result && res.result.success) {
        login(res.result.token);
        navigate(ROUTES.DIAGNOSTICS_HOME);
      } else {
        showError(t("somethingWrongLabel"));
      }
    } catch (error: any) {
      showError(t("somethingWrongLabel"));
    }
    setLoading(BOOLEAN_OPTIONS.FALSE);
  };

  return (
    <div className="container-fluid p-0 login-container d-flex justify-content-center align-items-center  h-100">
      <Helmet>
        <title>Appice | Diagnostics</title>
      </Helmet>
      {loading ? (
        <Spinner />
      ) : (
        <div className=" p-5 login-form-wrapper">
          <h4 className="pb-2 text-center">
            {t("signInTitleForDiagnostis")}
          </h4>
          <Form
            onFinish={handleSubmit}
            form={form}
            layout="vertical"
            validateTrigger={["onBlur"]}
          >
            <>
              <Form.Item
                label={t("emailLabel")}
                name="email"
                rules={[
                  {
                    required: true,
                    message: `${t("emptyEmailMsg")}`,
                  },
                ]}
              >
                <TextInput
                  placeholder={t("emailLabel")}
                  onChange={(e: any) => handleFieldChange({ email: e.target.value })}
                />
              </Form.Item>
              <Form.Item
                label={t("passwordLabel")}
                name="password"
                rules={[
                  { required: true, message: `${t("emptyPasswordMsg")}` },
                ]}
              >
                <TextInput
                  type="password"
                  onChange={(e: any) => handleFieldChange({ password: e.target.value })}
                  placeholder={t("passwordLabel")}
                />
              </Form.Item>
            </>

            <Form.Item>
              <PrimaryButton
                type="primary"
                className="w-100 mt-2 h-40"
                htmlType="submit"
              >
                {t("signInLabel")}
              </PrimaryButton>
            </Form.Item>
          </Form>
        </div>
      )}
    </div>
  );
};

export default Login; 